import { Component, OnDestroy, OnInit } from '@angular/core';
import { PromotedLinkList } from 'src/app/models/promoted-links/promoted-link-list.model';
import { PromotedLinksService } from 'src/app/services/promoted-links.service';
import { ToastsService } from 'src/app/services/toasts.service';
import { Base } from '../base/base';
import { EventTrackingService } from '../../services/event-tracking.service';
import { EventName } from '../../../environments/environment';

@Component({
  selector: 'safetydirector-promotedlinks',
  templateUrl: './promoted-links.component.html',
  styleUrls: ['./promoted-links.component.css']
})
export class PromotedLinksComponent extends Base implements OnInit, OnDestroy {
  private BusyA;
  public promotedLinks: PromotedLinkList[];

  constructor(private promotedLinksService: PromotedLinksService, private toastsService: ToastsService,
    private eventTrackingService: EventTrackingService 
  ) {
    super();
  }

  ngOnInit(): void {
    const industry = this.getIndustry();

    this.BusyA = this
      .promotedLinksService
      .getPromotedLinks(industry)
      .subscribe(result => {
        this.promotedLinks = result;
      });
  }

  ngOnDestroy(): void {
    if (this.BusyA) {
      this.BusyA.unsubscribe();
    }
  }

  onCardClick(promotedLink: any): void {
    // track event
    this.eventTrackingService.trackEvent('TrackEvent', {
      'Event': EventName.homePageTileNavigation
      ,'Tile': promotedLink.title
    });
    //console.log('Card clicked:', promotedLink);
  }

  // showBody(link: string, openInNewTab: boolean) {
  //   var target = openInNewTab ? "_blank" : "_self"
  //   window.open(link, target);
  // }
}

